/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import ContentWrapper from 'Component/ContentWrapper';
import Link from 'Component/Link';
import { NoMatch as SourceNoMatch } from 'SourceRoute/NoMatch/NoMatch.component';

import './NoMatch.style';

/** @namespace Pwa/Route/NoMatch/Component */
export class NoMatch extends SourceNoMatch {
    getStoreImage() {
        const {
            device: {
                isMobile
            },
            currentStoreCode
        } = this.props;

        const url = !isMobile ? `https://${window.location.hostname}/pub/errors/images/grafika_404_${currentStoreCode}.png` : `https://${window.location.hostname}/pub/errors/images/grafika_404_${currentStoreCode}_mobile.png`;

        return url;
    }

    render() {
        const source = this.getStoreImage();

        return (
            <main block="NoMatch" aria-label={ __('Page not found') }>
                <ContentWrapper
                  mix={ { block: 'NoMatch' } }
                  wrapperMix={ { block: 'NoMatch', elem: 'Wrapper' } }
                  label={ __('Page Not Found Content') }
                >
                    <img src={ source } alt="page-not-found-404" />
                    <Link
                      to="/"
                      block="NoMatch"
                      elem="Button"
                      mix={ { block: 'Button' } }
                    >
                        { __('Back to homepage') }
                    </Link>
                </ContentWrapper>
            </main>
        );
    }
}

export default NoMatch;
